import { Component } from "react"
import { Box, Button, Container, Typography } from "@mui/material"

class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error, info) {
        console.error("Unhandled render error", error, info)
    }

    handleRetry = () => {
        this.setState({ hasError: false })
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box sx={{ py: 10, bgcolor: "#f4f7fb", minHeight: "50vh" }}>
                    <Container maxWidth="sm" sx={{ textAlign: "center" }}>
                        <Typography variant="h5" fontWeight={800} color="#000435" gutterBottom>
                            Something went wrong
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                            An unexpected error occurred. Please refresh the page or try again.
                        </Typography>
                        <Button variant="contained" color="secondary" onClick={this.handleRetry}>
                            Try again
                        </Button>
                    </Container>
                </Box>
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
